import { AUTH_API_KEY } from "../Constants";

export const GenerateHeaderInformation = (accessToken: string, authMode: string = AUTH_API_KEY) => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization: `${authMode} ${accessToken}`,
});
